import { all } from "redux-saga/effects";
import authenticateSagas from "../reducers/authentication/sagas";
import restSagas from "./restSagas";

function* rootSaga() {
  yield all([...authenticateSagas, ...restSagas]);
}

export default rootSaga;
